import { api } from "../Apis/interceptor";

export const get = function (id) {
  return api.get("/api/v1/role/" + id);
};

export const all = function () {
  return api.get("/api/v1/role");
};

export const getAllRoles = function (customer_id, isAdminEnd) {
  return api.get("/api/v1/getAllRoles/" + customer_id, {
    params: { isAdminEnd: isAdminEnd },
  });
};

export const filter = function (skip, limit, pattern) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/role_filter", {
    params: { skip: skip, limit: limit, pattern: pattern },
  });
};

export const create = function (roleData) {
  return api.post("/api/v1/role/", roleData);
};

export const update = function (id, roleData) {
  return api.put("/api/v1/role/" + id, roleData);
};

export const updateRoles = function (id, roleData) {
  return api.put("/api/v1/updateRoles/" + id, roleData);
};

export const delete1 = function (id) {
  return api.delete("/api/v1/role/" + id);
};
export const getPageLike = function (pattern) {
  return api.get("/api/v1/roleLike/" + pattern);
};
export const roleSearch = function (cust_id, searchVal) {
  return api.get("/api/v1/roleSearch/" + searchVal + "/" + cust_id);
};

export const updateRole = function (id, roleData) {
  return api.put("/api/v1/updateRole/" + id, roleData);
};

export const removeRole = function (id, roleData) {
  return api.put("/api/v1/removeRole/" + id, roleData);
};

export const saveRole = function (id, roleData) {
  return api.put("/api/v1/saveRole/" + id, roleData);
};
/*When the free or individual user created*/
export const updateGatewayPermissions = function (id, roleName) {
  return api.put("/api/v1/updateGatewayPermissions/" + id, {
    role_name: roleName,
  });
};
